import "./_tabs.scss";

/**
 * Moved from src/components/common/CustomTabs - a plain, presentational
 * tab bar (not URL-synced; the host owns `activeTab` state and passes
 * `handleTabClick`). Same prop contract as the old component
 * (tabs/activeTab/handleTabClick/className/styles), rewritten to BEM +
 * `_styles/abstracts` tokens (the old version hardcoded raw hex colors).
 * Shared by CompanyDetails and SubscriptionDetails.
 *
 * `variant="underline"` swaps the default filled-pill look for the design's
 * underlined segment-control (a list page's "All accounts / Needs
 * attention / ..." strip) - additive, existing consumers are unaffected
 * since they never pass `variant`. A tab entry may also carry `count`
 * (rendered as a small badge) and `disabled` (for a tab with no real data
 * to filter by yet - still visible, just non-interactive).
 */
const Tabs = ({ tabs, activeTab, handleTabClick, className = "", styles, variant }) => (
  <div
    className={`tabs ${variant ? `tabs--${variant}` : ""} ${className}`.trim()}
    style={styles}
  >
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        className={`tabs__tab ${activeTab === tab.key ? "tabs__tab--active" : ""}`}
        disabled={tab.disabled}
        onClick={() => !tab.disabled && handleTabClick(tab.key)}
      >
        <span>{tab.label}</span>
        {tab.count !== undefined && <span className="tabs__count">{tab.count}</span>}
      </button>
    ))}
  </div>
);

export default Tabs;
